import { Modal } from "@mui/material";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import styles from "./index.module.scss";
import CommonButton from "../commonButton";
import { string } from "mobx-state-tree/dist/internal";

interface confirmModalProps {
  content: string;
  confirmHandler: () => void;
  closeHandler: () => void;
  trackingPointParams?: {
    exptag: string;
    "data-exptag-config": string;
    "data-exptag-json-param": string;
  };
}

const confirmModal: React.FC<confirmModalProps> = observer(({ content, confirmHandler, closeHandler, trackingPointParams }) => {
  const { t } = useTranslation();
  if (!content) {
    return null;
  }
  return (
    <Modal open={true} onClose={closeHandler} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <div className={styles.confirm_content} {...trackingPointParams}>
        <div className={styles.main_cont}>{content}</div>
        <div className={styles.oper_wrap}>
          <CommonButton variant="outlined" onClick={closeHandler}>
            {t("order.orderList.common.cancelBtnText")}
          </CommonButton>
          <CommonButton variant="contained" style={{ marginLeft: "12px" }} onClick={confirmHandler}>
            {t("common.btnText.delete")}
          </CommonButton>
        </div>
      </div>
    </Modal>
  );
});

export default confirmModal;
